import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { Col, Row } from "reactstrap";
import {
  getFormattedContactNumber,
  getModifiedObject,
  Toast,
  uploadImage,
} from "utility/helpers";
import OthersForm from "components/forms/Others";
import { genericPost, genericPut } from "services/services.general";
import ImgContainer from "components/common/img";
import defaultUserImage from "assets/img/default_user.png";
import { FILE_TYPE_IMAGE } from "constants/fileType";
import {
  FormContainer,
  FormHeaderSection,
  FormSection,
  HeaderText,
  ImageWrapper,
  UploadButton,
  UploadInput,
} from "assets/js/Styles";
import { validateOfficialDirectoryForm } from "../senator/utility";
import { POSITION_OTHERS } from "../constants";

const EditOthers = () => {
  const location = useLocation();
  const others = location.state?.others || null;

  const [isLoading, setIsLoading] = useState(false);

  const [formFields, setFormFields] = useState({
    lastName: "",
    firstName: "",
    fullName: "",
    contact: "",
    photo: "",
    photoName: "",
  });

  const navigate = useNavigate();

  const setOthersDetails = () => {
    const updatedFields = {
      ...formFields,
      lastName: others.lastName,
      firstName: others.firstName,
      fullName: others.fullName,
      contact: getFormattedContactNumber(others.contact),
      photo: others.photo || "",
    };

    if (others.photo) {
      const imgContainer = document.querySelector(".others-img");
      imgContainer.src = others.photo;
    }

    setFormFields(updatedFields);
  };

  const sendData = (formData) => {
    setIsLoading(true);

    if (others) {
      genericPut({
        url: `/official/${others.id}`,
        formData,
        callback: ({ isSuccess, msg }) => {
          setIsLoading(false);

          if (isSuccess) {
            navigate("/directory", {
              state: { view: POSITION_OTHERS },
            });

            Toast({
              type: 1,
              content: "Successfully edited details",
            });
          } else {
            Toast({
              type: 4,
              content: msg,
            });
          }
        },
      });
    } else {
      genericPost({
        url: "/official/create-others",
        formData,
        callback: ({ isSuccess, msg }) => {
          setIsLoading(false);

          if (isSuccess) {
            navigate("/directory", {
              state: { view: POSITION_OTHERS },
            });

            Toast({
              type: 1,
              content: "Successfully added directory.",
            });
          } else {
            Toast({
              type: 4,
              content: msg,
            });
          }
        },
      });
    }
  };

  const handleOnSubmit = async () => {
    const isValid = await validateOfficialDirectoryForm(formFields);

    if (isValid.valid) {
      const data = {
        // eslint-disable-next-line max-len
        fullName: `${formFields.firstName} ${formFields.lastName}`,
        firstName: formFields.firstName,
        lastName: formFields.lastName,
        contact: formFields.contact?.slice(1),
        position: POSITION_OTHERS,
      };

      if (formFields.cosNumber) {
        data.cosContact = formFields.cosNumber?.slice(1);
      }

      let initialData = {};

      if (others) {
        initialData = {
          firstName: others.firstName,
          lastName: others.lastName,
          fullName: others.fullName,
          contact: others.contact,
          photo: others.photo,
          position: POSITION_OTHERS,
        };
      }

      setIsLoading(true);

      if (typeof formFields.photo !== "string") {
        const fileName = await uploadImage({
          photo: formFields.photo,
          photoName: formFields.photoName,
        });
        data.photo = fileName;
      }

      const formData = others
        ? await getModifiedObject(initialData, data)
        : data;

      await sendData(formData);
    } else {
      Toast({
        type: 4,
        content: isValid.error,
      });
    }
  };

  const handleFileUpload = (evt) => {
    const file = evt.target.files[0];
    const reader = new FileReader();
    const fileTye = file.type.split("/")[0];

    if (fileTye === FILE_TYPE_IMAGE) {
      reader.onloadend = () => {
        const imgContainer = document.querySelector(".others-img");

        const fileName = others
          ? `${
              others.id
            }-${formFields.lastName.toLocaleLowerCase()}-${Date.now()}.${
              file.type.split("/")[1]
            }`
          : `${formFields.lastName.toLocaleLowerCase()}-${Date.now()}.${
              file.type.split("/")[1]
            }`;

        setFormFields({
          ...formFields,
          photo: file,
          photoName: fileName,
        });

        imgContainer.src = reader.result;
      };

      reader.readAsDataURL(file);
    } else {
      Toast({
        type: 4,
        content: "File uploaded must be an image.",
      });
    }
  };

  useEffect(() => {
    if (others !== null) {
      setOthersDetails();
    }
  }, [others]);

  return (
    <FormContainer>
      <Col className="container">
        <FormHeaderSection>
          <HeaderText>{!others ? "Add Others" : "Others Details"}</HeaderText>
        </FormHeaderSection>

        <FormSection>
          <Row>
            <Col
              xs="12"
              sm="6"
              lg="4"
            >
              <ImageWrapper>
                <ImgContainer
                  alt="others-img"
                  className="others-img"
                  src={defaultUserImage}
                  width="196px"
                  height="196px"
                />

                <UploadButton htmlFor="file-upload">
                  {"Upload Photo"}
                  <UploadInput
                    id="file-upload"
                    type="file"
                    onChange={handleFileUpload}
                  />
                </UploadButton>
              </ImageWrapper>
            </Col>
            <Col
              xs="12"
              sm="6"
              lg="8"
            >
              <OthersForm
                handleOnSubmit={handleOnSubmit}
                formFields={formFields}
                setFormFields={setFormFields}
                isLoading={isLoading}
                isModal={false}
              />
            </Col>
          </Row>
        </FormSection>
      </Col>
    </FormContainer>
  );
};

export default EditOthers;
